/*
*   File : data-table.js
*   Author : https://evoqins.com
*   Description : Data table component
*   Integrations : react-data-table-component
*   Version : 1.0.0
*/

import React, { memo } from 'react';
import DataTable from 'react-data-table-component';
import { Icon } from '../Icon';

const CustomDataTable = (props) => {

    return (
        <div>
            <DataTable columns={props.columns}
                data={props.data}
                pagination={false}
                selectableRows={props.selectableRows}
                expandableRows={!!props.expandableRowsComponent}
                striped={props.striped}
                expandOnRows
                expandableRowsComponent={props.expandableRowsComponent}
                expandableRowDisabled={props.expandableRowDisabled}
                expandableRowExpanded={row =>
                    typeof props.defaultExpandedRows === "function"
                        ? props.defaultExpandedRows(row)
                        : props.defaultExpandedRows
                }

                noTableHead={props.noTableHead}
                defaultSortFieldId={props.defaultSort}
                defaultSortAsc={true}
                sortIcon={<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M3.86193 2.86177C4.12228 2.60142 4.54439 2.60142 4.80474 2.86177L7.4714 5.52843C7.73175 5.78878 7.73175 6.21089 7.4714 6.47124C7.21106 6.73159 6.78895 6.73159 6.5286 6.47124L5 4.94265V12.6665C5 13.0347 4.70152 13.3332 4.33333 13.3332C3.96514 13.3332 3.66667 13.0347 3.66667 12.6665V4.94265L2.13807 6.47124C1.87772 6.73159 1.45561 6.73159 1.19526 6.47124C0.934913 6.21089 0.934913 5.78878 1.19526 5.52843L3.86193 2.86177Z" fill="#6D6D6D" />
                    <path d="M11.4711 13.138C11.2107 13.3983 10.7886 13.3983 10.5283 13.138L7.8616 10.4713C7.60125 10.211 7.60125 9.78886 7.8616 9.52851C8.12195 9.26816 8.54406 9.26816 8.80441 9.52851L10.333 11.0571L10.333 3.33325C10.333 2.96506 10.6315 2.66659 10.9997 2.66659C11.3679 2.66659 11.6663 2.96506 11.6663 3.33325L11.6663 11.0571L13.1949 9.52851C13.4553 9.26816 13.8774 9.26816 14.1377 9.52851C14.3981 9.78886 14.3981 10.211 14.1377 10.4713L11.4711 13.138Z" fill="#6D6D6D" />
                </svg>}
                // paginationComponent={CustomPagination}
                // onChangePage={props.onChangePage}
                onRowClicked={(e) => props.rowClick(e)}
            />

            {props.pagination &&
                <div className='pt-4 mt-1 px-4 d-flex justify-content-between align-items-center'>
                    <div>
                        <p className='mb-0 e-text-charleston-green e-alt-font e-font-14 e-font-weight-400 line-height-18px'>
                            Page {props.paginationDefaultPage} of {props.lastPage} ({props.paginationTotalRows} total entries)
                        </p>
                    </div>

                    <div className='d-flex align-items-center gap-2'>
                        <div className={`${props.paginationDefaultPage > 1 ? "" : "pe-none opacity-50"} table-arrow e-rotate-180 cursor-pointer`}
                            onClick={() => {
                                props.onChangePage(1)
                            }}>
                            <Icon icon="double-arrow"
                                className="d-flex"
                                color="#1C274C"
                                size={22} />
                        </div>
                        <div className={`${props.paginationDefaultPage > 1 ? "" : "pe-none opacity-50"} table-arrow e-rotate-90 cursor-pointer`}
                            onClick={() => {
                                props.onChangePage(props.paginationDefaultPage - 1)
                            }}>
                            <Icon icon="dropdown"
                                className="d-flex"
                                color="#1C274C"
                                size={20} />
                        </div>
                        <div className={`${props.lastPage === props.paginationDefaultPage ? "pe-none opacity-50" : ""} table-arrow e-rotate-270 cursor-pointer`}
                            onClick={() => {
                                props.onChangePage(props.paginationDefaultPage + 1)
                            }}>
                            <Icon icon="dropdown"
                                className="d-flex"
                                color="#1C274C"
                                size={20} />
                        </div>
                        <div className={`${props.lastPage === props.paginationDefaultPage ? "pe-none opacity-50" : ""} table-arrow cursor-pointer`}
                            onClick={() => {
                                props.onChangePage(props.lastPage)
                            }}>
                            <Icon icon="double-arrow"
                                className="d-flex"
                                color="#1C274C"
                                size={22} />
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

CustomDataTable.defaultProps = {
    rowClick: () => { },
    data: [],
    defaultExpandedRows: false,
}

export default memo(CustomDataTable);




